<template lang="pug">
.modal.is-active.is-clipped(@click="$emit('close')")
  .modal-background
  .modal-card(@keydown.esc="$emit('close')", tabindex="0", :id="id")
    .modal-card-body(@click.stop="")
      .upper-modal
        span Your Mining Key is:
        .conn-id
          .hint--bottom(
              @click="copyToClipboard(connectionId)"
              :aria-label="'Click to copy!'"
            ) {{ connectionId }}

      .middle-modal
        div.description.has-text-justify
          span Your Mining Key allows you to simplify your mining configuration by replacing the 
          span.w600 COIN:ADDRESS
          span.w600(v-if="memo") :MEMO 
          span.w600(v-else) &nbsp;
          span format. This is useful for old ASICs or third-party mining apps (*) that don’t support the 
          span.w600 : 
          span symbol or have a limited character length.
        div.mb-20.description.has-text-justify
          span Instead of 
          span.w600 {{ coin }}:YourAddress
          span.w600(v-if="memo") :YourMemo
          span.w600 .YourWorkerName
          span , use 
          span.w600 MiningKey.YourWorkerName 
          span for easier setup and cleaner configurations. (**)
        p.example-container.has-text-centered
          b.wb-ba.text-white-on-dark.fw-600.fs-15.address-field {{ coin }}:{{ address }}
          b.wb-ba.text-white-on-dark.fw-600.fs-15.address-field(v-if="memo") :{{ memo }}
          b.wb-ba.text-white-on-dark.fw-400.fs-15.address-field.light .YourWorkerName
        div.description.has-text-centered
          i.fa.fa-arrow-down
        p.example-container.has-text-centered
          b.wb-ba.text-white-on-dark.fw-600.fs-15.address-field {{ connectionId }}
          b.wb-ba.text-white-on-dark.fw-400.fs-15.address-field.light .YourWorkerName
        hr
        div.description.disclaimers
          div (*) Your Mining Key is designed for third-party mining apps or ASICs. Our unMiner app supports mining with addresses only.
          div (**) A worker name isn’t required — you can simply use your Mining Key in your setup and skip specifying a worker name.
  .modal-close(@click="$emit('close')")
</template>

<script>
import { nanoid } from 'nanoid'
export default {
  name: 'c_connection_id',
  data() {
    return {
      isLoading: true
    }
  },
  computed: {
    id() {
      return 'connection-id-modal-' + nanoid(10)
    },
    mode() {
      return this.$store.getters.mode
    }
  },
  watch: {
    mode() {
      let vm = this
      vm.createQR(function (error) {
        if (error) console.error('Error generating QR:', error.message)
      })
    }
  },
  props: ['address', 'memo', 'connectionId', 'coin'],
  mounted() {
    let vm = this
    vm.isLoading = true
    vm.createQR(function (error) {
      if (error) console.error('Error generating QR:', error.message)
      vm.isLoading = false
    })
    document.getElementById(vm.id).focus();
  },
  methods: {
    copyToClipboard(text) {
      let vm = this
      const clipboardData = event.clipboardData || window.clipboardData || navigator.clipboard;
      clipboardData.writeText(text);
      vm.$store.dispatch('notifySuccess', `Your Mining Key have been copied!`)
    }
  }
}
</script>

<style lang="stylus" scoped>

.modal
  z-index: 1000002;
.address-field
  font-family: 'Azeret Mono', monospace;
  &.light
    color #a1a1a1
.upper-modal
  font-size 14px
  padding 20px
  margin: 10px;
  margin-bottom: 5px;
  margin-top: 5px;
  border: solid #ccc 1px;
  border-radius: 15px;
  text-align center
  padding-bottom 10px
  text-align: center
  .conn-id
    cursor: pointer
    font-size 36px
    font-family: Azeret Mono, monospace;
    font-weight: 700

.middle-modal
  margin-top 10px
  .qr-container
    position relative
    margin-bottom -5px
  .is-loading
    padding-top 8px
  i
    font-size 20px
    color #A4A4A4
    padding-bottom 0px
  .description
    font-size 14px
    font-weight 400
    padding 10px
    word-wrap break-word
    &.disclaimers
      font-size 11px
      margin-top -15px
  .example-container
    width 100%
    padding: 15px;
    font-weight: 700;
    border: 2px dashed #efefef;
    font-size: 18px;
    word-break: break-word;

.modal-close
  &::before
    width 15px
  &::after
    height 15px
.modal-background
  background-color rgba(10,10,10,.6)
  cursor: pointer
.modal-card-body
  border-radius 7.5px

.modal-card
  outline none

.get-app-image
  flex 1
  padding 5px 5px
  &.android
    img
      height 40px
    
html.dark
  i
    color #969696
  .modal-card-body
    background-color #2c2c2c
  .description
    color #fff
  .upper-modal
    color #fff
    i
      color #fff

@media (max-width: 768px)
  .modal-card
    padding-left 20px
    padding-right 20px
  .upper-modal
    display flex
    flex-direction column
    align-items center
    text-align left
    .column
      padding 5px
    

@media (max-width: 450px)
  .modal-card
    margin-top 30px
</style>



// WEBPACK FOOTER //
// c_connection_id.vue?5ede30ea